import * as React from 'react'
import { Button, Divider, Grid, Message, MessageHeader, MessageItem, MessageList, Segment } from 'semantic-ui-react'
import { common } from '../../../../../utils/common'
import { homeService, itemService } from '../../../../../services'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import { vietqr } from '../../../../../utils/vietqr'
import { QrCodeImage } from '../../../../components/QrCodeImage'

type RequestRollInfoProps = {
  rollRequest: IRollRequest,
  rollRequestInfo: IRollRequestInfo,
}
type RequestRollInfoState = {
  activeIndex: number,
  disableNotify: boolean,
  bankInfoList: IBankInfo[],
}

export class RequestRollSuccessInfo extends React.Component<RequestRollInfoProps, RequestRollInfoState> {
  state = {
    activeIndex: 0,
    disableNotify: false,
    bankInfoList: [],
  }

  componentDidMount() {
    homeService.getBankInfoList()
      .then(value => this.setState({bankInfoList: value}))
  }

  renderBankInfo = (bankInfo?: IBankInfo) => {
    return (
      <div>
        <Message>
          {bankInfo &&
            <div dangerouslySetInnerHTML={{__html: bankInfo.information}}/>
          }
        </Message>
        <CopyToClipboard
          text={bankInfo ? bankInfo.account : ''}
        >
          <Button size="mini" color="green">Sao chép số tài khoản</Button>
        </CopyToClipboard>
      </div>
    )
  }

  onClickNotify = () => {
    this.setState({
      disableNotify: true,
    })
    const {rollRequest} = this.props
    itemService.notifySendMoney(rollRequest)
  }

  render() {
    const {rollRequest} = this.props
    const {disableNotify} = this.state
    const totalAmount = common.calculateFee(rollRequest.totalVnd, rollRequest.feeFactor)
    const content = `R${rollRequest.id} mua steam`
    const bankInfo = common.getActiveBank(rollRequest.bank, this.state.bankInfoList)
    const srcQrCode = bankInfo ?
      vietqr.generateUrl(bankInfo.code, bankInfo.account, totalAmount, content, bankInfo.accountName)
      : ''

    return (
      <Segment>
        <Message color={'green'}>
          Thành công! Mã đặt hàng của bạn là: R{rollRequest.id}
        </Message>
        <Message color={'blue'}>
          <MessageHeader>
            Thông tin
          </MessageHeader>
          <MessageList>
            <MessageItem>SteamID: {rollRequest.steamId}</MessageItem>
            <MessageItem>Tổng value: {rollRequest.totalValue.toLocaleString('us')}</MessageItem>
            <MessageItem>Tổng vnđ: {rollRequest.totalVnd.toLocaleString('vn')}</MessageItem>
            <MessageItem>
              Phí: {rollRequest.feeFactor ? `${(rollRequest.feeFactor * 100).toLocaleString('vn')} %` : '0'}
            </MessageItem>
            <MessageItem>
              Tổng vnđ + phí: <strong>{totalAmount.toLocaleString('vn')}</strong>
            </MessageItem>
          </MessageList>
        </Message>
        <Message color={'blue'}>
          <MessageHeader>
            Thông tin thanh toán
          </MessageHeader>
          <Grid columns={2} stackable={true}>
            <Grid.Row>
              {srcQrCode &&
                <Grid.Column>
                  Quét mã QR để thanh toán
                  <QrCodeImage src={srcQrCode}/>
                </Grid.Column>
              }
              <Grid.Column>
                {srcQrCode && <Divider>Hoặc</Divider>}
                Chuyển khoản với
                <br/>Nội dung: <strong>{content}</strong>
                <CopyToClipboard
                  text={`R${rollRequest.id} mua steam`}
                >
                  <Button size="mini" color="green">Sao chép</Button>
                </CopyToClipboard>
                <br/>Số tiền: <strong>{totalAmount.toLocaleString('vn')}</strong> đến tài khoản:
                {this.renderBankInfo(bankInfo)}
              </Grid.Column>

            </Grid.Row>
          </Grid>
        </Message>

        <Message color={'orange'}>
          Sau khi chuyển khoản thành công, bạn vui lòng bấm vào nút bên dưới để thông báo đã nạp tiền nhé! Xin cảm ơn!
          <br/>
          <Button disabled={disableNotify} primary={true} onClick={this.onClickNotify}>Đã chuyển tiền</Button>
        </Message>
      </Segment>)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/containers/RequestRollSuccessInfo.tsx